import axios from '@/libs/axios';

class CampaignClient {
  constructor() {
    this.api = axios;
  }

  async list(params) {
    const { data } = await this.api.get('/campanhas', { params });
    return data;
  }

  async getById(id) {
    const { data } = await this.api.get(`/campanhas/${id}`);
    return data;
  }

  async create(payload) {
    const { data } = await this.api.post('/campanhas', payload);
    return data;
  }

  async update(id, payload) {
    const { data } = await this.api.patch(`/campanhas/${id}`, payload);
    return data;
  }

  async remove(id) {
    const { data } = await this.api.delete(`/campanhas/${id}`);
    return data;
  }

  async activate(id) {
    const { data } = await this.api.post(`/campanhas/${id}/ativar`);
    return data;
  }

  async pause(id) {
    const { data } = await this.api.post(`/campanhas/${id}/pausar`);
    return data;
  }

  async listSteps(id) {
    const { data } = await this.api.get(`/campanhas/${id}/steps`);
    return data;
  }

  async createStep(id, payload) {
    const { data } = await this.api.post(`/campanhas/${id}/steps`, payload);
    return data;
  }

  async updateStep(id, stepId, payload) {
    const { data } = await this.api.patch(`/campanhas/${id}/steps/${stepId}`, payload);
    return data;
  }

  async deleteStep(id, stepId) {
    const { data } = await this.api.delete(`/campanhas/${id}/steps/${stepId}`);
    return data;
  }

  async reorderSteps(id, stepIds) {
    const { data } = await this.api.post(`/campanhas/${id}/steps/reorder`, { stepIds });
    return data;
  }

  async listRecipients(id, params) {
    const { data } = await this.api.get(`/campanhas/${id}/recipients`, { params });
    return data;
  }

  async addRecipients(id, clienteIds) {
    const { data } = await this.api.post(`/campanhas/${id}/recipients`, { clienteIds });
    return data;
  }

  async removeRecipient(id, recipientId) {
    const { data } = await this.api.delete(`/campanhas/${id}/recipients/${recipientId}`);
    return data;
  }

  async getStats(id) {
    const { data } = await this.api.get(`/campanhas/${id}/stats`);
    return data;
  }

  async searchClients(query) {
    const { data } = await this.api.get('/campanhas/search/clients', { params: { query } });
    return data;
  }
}

export default new CampaignClient();
